import React from 'react';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import PhoneIcon from './PhoneIcon.smava';
import useEmotionStyles from '../../hooks/useEmotionStyles';
var styles = function (theme) { return ({
    phoneIcon: {
        fill: '#848484',
        height: '24px',
        width: '24px',
    },
    phoneNumber: {
        textDecoration: 'none',
        color: theme.palette.grey[900],
        transition: 'color 0.25s',
        '&:hover': {
            color: 'rgb(116, 196, 127)',
        },
    },
    roundedButton: {
        borderRadius: '50% !important',
    },
}); };
var PhoneBox = function (_a) {
    var _b = _a.phoneNumber, phoneNumber = _b === void 0 ? '0800 000 98 00' : _b;
    var classes = useEmotionStyles(styles);
    return (React.createElement(Box, { display: "flex", alignItems: "center" },
        React.createElement("a", { className: classes.phoneNumber, href: "tel:".concat(phoneNumber) },
            React.createElement(IconButton, { "aria-label": "Anrufen", className: classes.roundedButton },
                React.createElement(PhoneIcon, { className: classes.phoneIcon }))),
        React.createElement(Box, { display: { xs: 'none', sm: 'flex' }, flexDirection: "column", ml: 1 },
            React.createElement(Typography, { variant: "body2" },
                React.createElement("a", { className: classes.phoneNumber, href: "tel:".concat(phoneNumber) }, phoneNumber)),
            React.createElement(Typography, { color: "textSecondary", variant: "body2" }, "Kostenlose Beratung"))));
};
export default PhoneBox;
